var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCommentDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 19.85V5.3C21.5 4.8 21.325 4.375 20.975 4.025C20.625 3.675 20.2 3.5 19.7 3.5H4.3C3.8 3.5 3.375 3.675 3.025 4.025C2.675 4.375 2.5 4.8 2.5 5.3V16.7C2.5 17.2 2.675 17.625 3.025 17.975C3.375 18.325 3.8 18.5 4.3 18.5H17.95L19.975 20.5C20.2583 20.7833 20.5833 20.846 20.95 20.688C21.3167 20.5293 21.5 20.25 21.5 19.85ZM20 18.425L18.575 17H4.3C4.21667 17 4.14567 16.9707 4.087 16.912C4.029 16.854 4 16.7833 4 16.7V5.3C4 5.21667 4.029 5.14567 4.087 5.087C4.14567 5.029 4.21667 5 4.3 5H19.7C19.7833 5 19.854 5.029 19.912 5.087C19.9707 5.14567 20 5.21667 20 5.3V18.425ZM20 5.3V5V18.425V5.3Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommentDefault);
export default __webpack_public_path__ + "static/media/ic-comment-default.0ca65daf1a5cc90c2fa5de23400c8d2f.svg";
export { ForwardRef as ReactComponent };